































import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import BaseH4 from '../base-headings/_base-h4.vue';
import BaseIcon from '../base-icon/_base-icon.vue';
import type { RainbowColor } from '../../styles/enums/RainbowColor';
import { MessageType } from './types/message-types';

export default defineComponent({
  name: 'BaseMessage',
  components: {
    BaseH4,
    BaseIcon,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: MessageType.Info,
    },
    color: {
      type: String as PropType<RainbowColor>,
      default: null,
    },
  },
  setup() {
    return { MessageType };
  },
});
